<template>
  <div class="listmain ">
    <h1 class="firTitle">OrionOS支付订单接口（创建订单/订单查询）</h1>
    <p>OrionOS为开发者提供支付订单接口，开发者可通过该接口创建订单以及查询订单状态。
    </p>
    <h5 class="thirdTitle">场景</h5>
    <p>
      当用户点播到付费资源，技能开发者需要调用订单查询接口，查看订单支付状态，如果已经支付，则下发付费资源。 如果用户未支付，开发者需要调用创建订单接口，并在接口返回结果后，调用支付信息流卡片，提醒用户支付。用户支付完成后，即可体验该付费资源。
    </p>
    <h3 class="sedTitle">1.接口设计</h3>
    <h5 class=" thirdTitle">1.1公共参数:
    </h5>
    <table>
      <tr>
        <th>字段名</th>
        <th>类型</th>
        <th>必填</th>
        <th>描述</th>
      </tr>
      <tr>
        <td>skill_id</td>
        <td>String</td>
        <td>是</td>
        <td>猎户OS技能唯一标识</td>
      </tr>
      <tr>
        <td>client_id</td>
        <td>String </td>
        <td>是</td>
        <td>猎户OS client_id</td>

      </tr>
      <tr>
        <td>timestamp</td>
        <td>Integer</td>
        <td>是</td>
        <td>Unix时间戳（秒）</td>
      </tr>

      <tr>
        <td>sign</td>
        <td>String</td>
        <td>是</td>
        <td>签名,生成算法见签名算法</td>
      </tr>

    </table>
    <h5 class="codeTitle">签名算法：
    </h5>
     <highlight-code lang="javascript">
                (1)将除了sign以外的所有请求参数按照参数名的字典序排序
                (2)将排序后的参数键值对用&拼接，即拼接成key1=val1&key2=val2&...
                (3)将以上字符串再拼接&skill_secret={密钥}
                (4)将得到的字符串进行Base64编码（注意Base64编码时要设置字符集为utf8）
                (5)对以上得到的值MD5获得32位字符串即为sign的值
               </highlight-code>


    <h5 class=" thirdTitle">1.2 /order/create 创建订单接口
    </h5>

    <p>接口描述：创建订单
      <br> 接口使用者需从服务端发起调用（签名使用到的密钥只能保存在服务端）
      <br> 接口协议：HTTP 1.1
      <br> 接口地址：https://pay.ainirobot.com/order/create
      <br> Content-Type："application/x-www-form-urlencoded;charset=UTF-8"
      <br> Http Method：POST
    </p>
    <h5 class="codeTitle">请求参数：
    </h5>
    <table>
      <tr>
        <th>字段名</th>
        <th>类型</th>
        <th>必填</th>
        <th> 最大长度</th>

        <th>描述</th>
      </tr>
      <tr>
        <td>open_id</td>
        <td>String</td>
        <td>是</td>
        <td>30</td>

        <td>猎户OS用户openId</td>
      </tr>
      <tr>
        <td>product_no</td>
        <td>String </td>
        <td>是</td>
        <td>32</td>

        <td>商品编号</td>

      </tr>
      <tr>
        <td>subject</td>
        <td>String</td>
        <td>是</td>

        <td>128</td>
        <td>商品的标题/交易标题/订单标题/订单关键字等。</td>
      </tr>

      <tr>
        <td>detail</td>
        <td>String</td>
        <td>是</td>
        <td>128</td>
        <td>对一笔交易的具体描述信息。</td>
      </tr>
      <tr>
        <td>total_amount</td>
        <td>Price</td>
        <td>是</td>
        <td>9</td>
        <td>订单总金额，单位为元，精确到小数点后两位，取值范围[0.01,100000000]</td>
      </tr>
      <tr>
        <td>time_expire</td>
        <td>String</td>
        <td>否</td>
        <td>14</td>
        <td>支付过期绝对时间</td>
      </tr>

    </table>
    <h5 class="codeTitle">
      Success-Response
    </h5>


    <p>HTTP/1.1 200 OK
      <br> Content-Type: application/json;charset=UTF-8
    </p>
    <h5 class="codeTitle">
      返回值字段如下：
    </h5>

    <table>
      <tr>
        <th>字段名</th>
        <th>类型</th>
        <th>描述</th>
      </tr>
      <tr>
        <td>order_no</td>
        <td>String</td>
        <td>订单号</td>
      </tr>
      <tr>
        <td>pay_client_id</td>
        <td>String </td>
        <td>支付模块接入标识</td>
      </tr>


      <tr>
        <td>pay_access_token</td>
        <td>String</td>
        <td>支付模块访问令牌</td>
      </tr>

    </table>

    <h5 class="codeTitle">
      Example：
    </h5>
     <highlight-code lang="javascript">
                    {
                    "order_no":"14975469443552573900142388202000000000000",
                    "pay_client_id":"orion.pay.1508466592633",
                      "pay_access_token":"63164af2a11a46159f6e3c8f7b3232ae"
                    }
               </highlight-code>
    <h5 class="codeTitle">
      Error-Response
    </h5>



    <p>HTTP/1.1 400
      <br> Content-Type: application/json;charset=UTF-8
    </p>
    <h5 class="codeTitle">
      返回值字段如下：
    </h5>
    <table>
      <tr>
        <th>字段名</th>
        <th>类型</th>
        <th>描述</th>
      </tr>
      <tr>
        <td>code</td>
        <td>Integer</td>
        <td>Integer</td>
      </tr>
      <tr>
        <td>desc</td>
        <td>String </td>
        <td>错误描述</td>
      </tr>
    </table>
    <h5 class="codeTitle">
      Example：
    </h5>
     <highlight-code lang="javascript">
                {
                   "code": 700,
                   "desc": "参数异常"
                }
               </highlight-code>




    <h5 class=" thirdTitle">1.3 /order/info 订单查询接口
    </h5>

    <p>接口描述：获得订单信息
      <br> 接口协议：HTTP 1.1
      <br> 接口地址：https://pay.ainirobot.com/order/create
      <br> Content-Type："application/x-www-form-urlencoded;charset=UTF-8"
      <br> Http Method：GET/POST
      <br> 调用方：skill服务端
    </p>
    <h5 class="codeTitle">请求参数：
    </h5>
    <table>
      <tr>
        <th>字段名</th>
        <th>类型</th>
        <th>必填</th>
        <th> 最大长度</th>

        <th>描述</th>
      </tr>
      <tr>
        <td>order_no</td>
        <td>String</td>
        <td>否</td>
        <td>50</td>
        <td>订单号, open_id与product_no为空时必填</td>
      </tr>
      <tr>
        <td>open_id</td>
        <td>String </td>
        <td>否</td>
        <td>30</td>
        <td>猎户OS用户openId，订单号为空时必填</td>
      </tr>
      <tr>
        <td>product_no</td>
        <td>String</td>
        <td>否</td>
        <td>否</td>
        <td>商品编号，订单号为空时必填</td>
      </tr>

    </table>
    <h5 class="codeTitle">
      Success-Response
    </h5>


    <p>HTTP/1.1 200 OK
      <br>Content-Type: application/json;charset=UTF-8-8
    </p>
    <h5 class="codeTitle">
      返回值字段如下：
    </h5>

    <table>
      <tr>
        <th>字段名</th>
        <th>类型</th>
        <th>描述</th>
      </tr>
      <tr>
        <td>order_no</td>
        <td>String</td>
        <td>订单号</td>
      </tr>
      <tr>
        <td>client_id</td>
        <td>String </td>
        <td>猎户OS client_id</td>
      </tr>
      <tr>
        <td>skill_id</td>
        <td>String</td>
        <td>猎户OS技能id</td>
      </tr>
      <tr>
        <td>open_id</td>
        <td>String</td>
        <td>猎户OS用户openId</td>
      </tr>
      <tr>
        <td>product_no</td>
        <td>String</td>
        <td>商品编号</td>
      </tr>
      <tr>
        <td>subject</td>
        <td>String</td>
        <td>商品的标题/交易标题/订单标题/订单关键字</td>
      </tr>
      <tr>
        <td>detail</td>
        <td>String</td>
        <td>对一笔交易的具体描述信息</td>
      </tr>
      <tr>
        <td>total_amount</td>
        <td>Price</td>
        <td>订单总金额</td>
      </tr>
      <tr>
        <td>status</td>
        <td>Integer</td>
        <td>订单状态: 1：DRAFT 3：SUCCESS 4：CLOSED
        </td>
      </tr>


    </table>

    <h5 class="codeTitle">
      Example：
    </h5>
     <highlight-code lang="javascript">
                {
                "order_no":"14975469445281308719860810495000000000000",
                "client_id":"orion.ovs.client.1503470121484",
                "skill_id":"orion.ovs.skill.1508466592533 ",
                "open_id":"+lKop6j7pdfSrA9kHt26MQ==",
                "product_no":"p123234563423",
                "subject":"xxxxxxxxxxxxxxxxxxx",
                "detail":"xxxxxxxxxxxx",
                "total_amount ":10.01,
                "status":1
                }
               </highlight-code>


    <h5 class="codeTitle">
      Error-Response
    </h5>



    <p>HTTP/1.1 400
      <br> Content-Type: application/json;charset=UTF-8
    </p>
    <h5 class="codeTitle">
      返回值字段如下：
    </h5>
    <table>
      <tr>
        <th>字段名</th>
        <th>类型</th>
        <th>描述</th>
      </tr>
      <tr>
        <td>code</td>
        <td>Integer</td>
        <td>错误码</td>
      </tr>
      <tr>
        <td>desc</td>
        <td>String </td>
        <td>错误描述</td>
      </tr>
    </table>
    <h5 class="codeTitle">
      Example：
    </h5>
     <highlight-code lang="javascript">
                {
                   "code": 700,
                   "desc": "参数异常"
                }
               </highlight-code>










  </div>
</template>

<script>
  export default {
    name: ""
  };

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      margin: 10px 0;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/tutor/zdyjn_zfdd.vue